<template>
  <div class="app-container">
    <title-screen title="9"></title-screen>
    <div class="anken-detail">
      <AnkenInfo :id="ankenId" @ankenInfoLoad="ankenInfoLoad"></AnkenInfo>
    </div>
    <div class="chat-main">
      <div class="chat-history">
        <Message v-for="h in history"
                 :id="h.id"
                 :key="h.id"
                 :is-delete="h.senderType === 'MEMBER' && +currentUser.id === +h.senderId"
                 :name="h.senderType === 'MEMBER' ? '本人' : h.senderName"
                 v-bind:content="h.content"
                 v-bind:time="h.createdAt"
                 :type="h.senderType === 'MEMBER' ? 'myself': 'other'"
                 @deleteMessage="deleteMessage"
        ></Message>
      </div>
      <el-form
        class="chat-form"
        :model="chatForm"
        :rules="rules"
        ref="chatForm"
        @submit.native.prevent="sendMessage"
      >
      <div class="message">
        <el-row>
          <el-col style="font-size: 14px; padding-bottom: 4px">入力欄</el-col>
        </el-row>
        <el-form-item prop="message">
        <el-input
          type="textarea"
          :rows="4"
          resize="none"
          placeholder="こちらにメッセージを入力してください。"
          v-model="chatForm.message"
          @input="handleInput"
          >
        </el-input>
        </el-form-item>
      </div>
      <div class="send-message">
        <el-button class="gtm_line_send_line" :disabled="isError" native-type="submit"><span class="gtm_line_send_line">送信ボタン</span></el-button>
      </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import ConversationApi from '@/api/conversation'
  import Message from '@/components/chat/Message'
  import { HANDLE_MEMBER_NEW_MESSAGE_NOTIFICATION } from '@/store/actions.type'
  import TitleScreen from '@/components/common/TitleScreen'
  import AnkenInfo from '../38_anken/AnkenInfo.vue'
  import { mapGetters } from 'vuex'
  import { isIE } from '@/common/useragent'
  const VUE_APP_GET_MESSAGE_TIMEOUT = process.env.VUE_APP_GET_MESSAGE_TIMEOUT

  export default {
    name: 'Chat',
    components: {
      'Message': Message,
      'title-screen': TitleScreen,
       AnkenInfo
    },
    data () {
      return {
        intervalGetMessage: null,
        history: [],
        chatForm: {
          message: ''
        },
        ankenId: 0,
        isAnkenInfoLoaded: false,
        isError: true,
        rules: {
          message: [
            { required: true, message: '入力欄に入力してください', trigger: 'blue' },
            { max: 5000, message: '5000文字以内で入力してください' }
          ]
        }
      }
    },
    methods: {
      async loadData () {
          const res = await ConversationApi.getHistory(this.ankenId)
          if (this.needsUpdate(res.data)) {
            this.history = res.data
            this.updateConversationSeen()
          }
      },
      needsUpdate (data) {
          if (this.history.length !== data.length) {
              return true
          }
          for (let i = 0; i < this.history.length; i++) {
              if (this.history[i].id !== data[i].id) {
                  return true
              }
          }
          return false
      },
      ankenInfoLoad (val) {
          this.isAnkenInfoLoaded = val
      },
      async sendMessage () {
        this.$refs['chatForm'].validate((valid) => {
          if (valid) {
            const self = this
            ConversationApi
              .sendMessage({ content: this.chatForm.message }, this.ankenId)
              .then(res => {
                self.chatForm.message = ''
                const newMessage = res.data
                self.addNewMessage(newMessage)
              })
          }
        })
      },
      addNewMessage (newMessage) {
        const oldMessage = this.history.find(h => +h.id === +newMessage.id)
        if (!oldMessage) {
          this.history.push(newMessage)
        }
      },
        async deleteMessage (id) {
            await ConversationApi.deleteMessage(id)
            const index = this.history.findIndex(h => +h.id === +id)
            this.history.splice(index, 1)
        },
      updateConversationSeen () {
        this.$store.dispatch(HANDLE_MEMBER_NEW_MESSAGE_NOTIFICATION, { 'hasNewMessage': false })
      },
      scrollChatToBottom () {
        const container = this.$el.querySelector('.chat-history')
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      },
      registerIntervalGetMessage: function () {
        if (!this.intervalGetMessage) {
          this.intervalGetMessage = setInterval(this.loadData, VUE_APP_GET_MESSAGE_TIMEOUT * 1000)
        }
      },
      clearIntervalGetMessage: function () {
        clearInterval(this.intervalGetMessage)
        this.intervalGetMessage = null
      },
      scrollToChat () {
        this.$nextTick(() => {
            const ankenViews = document.getElementsByClassName('anken-info')
            if (ankenViews.length > 0) {
                const ankenView = ankenViews[0]
                if (ankenView) {
                    var navHeight = 0
                    if (window.innerWidth > 600 && window.innerHeight > 400) {
                        const navViews = document.getElementsByClassName('gnav nav-height')
                        if (navViews.length > 0) {
                            const navView = navViews[0]
                            if (navView) {
                                navHeight = navView.offsetHeight
                                if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                            }
                        }
                    }
                    const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
                    window.scroll(0, scrollTop)
                }
            }
        })
      },
      handleInput () {
        this.$refs['chatForm'].validate((valid) => {
          this.isError = !valid
        })
      }
    },
    computed: {
        ...mapGetters(['currentUser'])
    },
    created () {
      this.ankenId = parseInt(this.$route.params.ankenId)
      this.loadData()
      this.registerIntervalGetMessage()
    },
    mounted () {
        this.scrollToChat()
    },
    beforeDestroy () {
      this.clearIntervalGetMessage()
    },
    watch: {
      history: function () {
        this.$nextTick(() => this.scrollChatToBottom())
      },
      isAnkenInfoLoaded: function () {
          this.scrollToChat()
      }
    }
  }
</script>

<style scoped>
  .chat-main {
    padding: 0px 30px;
  }
  .chat-history {
    width: 100%;
    height: 400px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    background-color: #fff;
    overflow: auto;
    padding: 15px;
  }
  .message {
    margin-top: 20px;
  }
  .send-message {
    margin-top: 20px;
    text-align: center;
  }
</style>

<style>
  .message .el-form-item__error {
    font-size: 15px;
  }
</style>
